<div class="kl-loading" *ngIf="show">
  <div class="indicator">
    <div class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
  </div>
  <div class="indicator-text">
    {{ loadingText | translate }}
  </div>
</div>
